// removed by extract-text-webpack-plugin
module.exports = {"topComment":"_3Q59d","topCommentLabel":"fqcBx"};


//////////////////
// WEBPACK FOOTER
// ./app/components/top-comment/top-comment.scss
// module id = 1014
// module chunks = 0 3 5